/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProximityZone } from './ProximityZone';
import {
    ProximityZoneFromJSON,
    ProximityZoneFromJSONTyped,
    ProximityZoneToJSON,
    ProximityZoneToJSONTyped,
} from './ProximityZone';

/**
 * 
 * @export
 * @interface VehicleZoneViolationEvent
 */
export interface VehicleZoneViolationEvent {
    /**
     * Primary key, provided by clients to provide idempotent inserts. See `docs/backend/Offline-Synchronization.md` for details.
     * @type {string}
     * @memberof VehicleZoneViolationEvent
     */
    id: string;
    /**
     * This is the time at which the movement has been reported to our system. Since movements might happen in offline mode, `created_at` and `time` might differ considerably.
     * @type {Date}
     * @memberof VehicleZoneViolationEvent
     */
    createdAt: Date;
    /**
     * The vehicle this movement belongs to. Although this is reported by the vehicle device, we record the vehicle that was assigned to the device at the time of recording, because vehicle-to-vehicle-device assigments can change.
     * @type {string}
     * @memberof VehicleZoneViolationEvent
     */
    vehicleId: string;
    /**
     * The user that was logged in
     * @type {string}
     * @memberof VehicleZoneViolationEvent
     */
    userId?: string | null;
    /**
     * This is the on-device time the movement was recorded at.
     * @type {Date}
     * @memberof VehicleZoneViolationEvent
     */
    time: Date;
    /**
     * Minimum distance in cm
     * @type {number}
     * @memberof VehicleZoneViolationEvent
     */
    minimumDistanceCm: number;
    /**
     * Other vehicle that was detected
     * @type {string}
     * @memberof VehicleZoneViolationEvent
     */
    otherVehicleId: string;
    /**
     * Zone which was violated
     * @type {ProximityZone}
     * @memberof VehicleZoneViolationEvent
     */
    triggeredZone: ProximityZone;
}



/**
 * Check if a given object implements the VehicleZoneViolationEvent interface.
 */
export function instanceOfVehicleZoneViolationEvent(value: object): value is VehicleZoneViolationEvent {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('vehicleId' in value) || value['vehicleId'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if (!('minimumDistanceCm' in value) || value['minimumDistanceCm'] === undefined) return false;
    if (!('otherVehicleId' in value) || value['otherVehicleId'] === undefined) return false;
    if (!('triggeredZone' in value) || value['triggeredZone'] === undefined) return false;
    return true;
}

export function VehicleZoneViolationEventFromJSON(json: any): VehicleZoneViolationEvent {
    return VehicleZoneViolationEventFromJSONTyped(json, false);
}

export function VehicleZoneViolationEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleZoneViolationEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'vehicleId': json['vehicleId'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'time': (new Date(json['time'])),
        'minimumDistanceCm': json['minimumDistanceCm'],
        'otherVehicleId': json['otherVehicleId'],
        'triggeredZone': ProximityZoneFromJSON(json['triggeredZone']),
    };
}

export function VehicleZoneViolationEventToJSON(json: any): VehicleZoneViolationEvent {
    return VehicleZoneViolationEventToJSONTyped(json, false);
}

export function VehicleZoneViolationEventToJSONTyped(value?: VehicleZoneViolationEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'vehicleId': value['vehicleId'],
        'userId': value['userId'],
        'time': value['time'].toISOString(),
        'minimumDistanceCm': value['minimumDistanceCm'],
        'otherVehicleId': value['otherVehicleId'],
        'triggeredZone': ProximityZoneToJSON(value['triggeredZone']),
    };
}

